'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defineMaskList;
/**
 *
 * @param {String} mask
 * @param format
 * @returns {Array}
 */
function defineMaskList(mask, format) {
    if (!mask) {
        return [];
    }

    var stack = [];
    var escape = false;

    for (var i = 0; i < mask.length; i++) {
        var item = format[mask[i]];
        if (escape && item) {
            item = null;
            escape = false;
        }
        if (!item) {
            if (!escape && mask[i] === '\\') {
                escape = true;
                continue;
            }
            escape = false;
            stack.push({
                char: mask[i],
                next: null
            });
        } else if (item.regexp) {
            stack.push(item);
        }
    }

    return stack;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/input-core/lib/functions/defineMaskList.js
// module id = 178
// module chunks = 0